import { render } from "./StickyContactWidget.vue?vue&type=template&id=5f041f0c&scoped=true"
import script from "./StickyContactWidget.vue?vue&type=script&lang=js"
export * from "./StickyContactWidget.vue?vue&type=script&lang=js"

import "./StickyContactWidget.vue?vue&type=style&index=0&id=5f041f0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f041f0c"]])

export default __exports__